import React from 'react';
import { useSEO } from '../../hooks/useSEO';
import { APP_METADATA } from '../../config/constants';
import PageLayout from '../../components/PageLayout/PageLayout';
import InfoCard from '../../components/InfoCard/InfoCard';
import { experienceData } from '../../data/experienceData';
// Styles are now centralized in src/styles/

const Resume = () => {
  useSEO({
    title: 'Experience',
    description: `Professional experience and work history of ${APP_METADATA.author}`,
    keywords: `${APP_METADATA.keywords}, Experience, Work History, Resume`,
  });

  return (
    <PageLayout title="Experience" showTabs>
      <div className="gallery">
        {experienceData.map((experience) => (
          <InfoCard
            key={experience.id}
            image={experience.image}
            imageAlt={experience.imageAlt}
            title={experience.title}
            subtitle={experience.subtitle}
            date={experience.date}
            description={experience.description}
            items={experience.items}
          />
        ))}
      </div>
    </PageLayout>
  );
};

export default Resume;

